//台账管理
export default [{
  path: '/archives',
  name: 'archives',
  component: () => import('@/page/archives/archives.vue')
}, {//历史补录
  path: '/historicalSupplement',
  name: 'historicalSupplement',
  component: () => import('@/page/archives/historicalSupplement.vue')
}, {
  path: '/archivesType',
  name: 'archivesType',
  component: () => import('@/page/archives/archivesType.vue')
}, {
  path: '/archivesType',
  name: 'archivesType',
  component: () => import('@/page/archives/archivesType.vue')
}, {
  path: '/enumSetting',
  name: 'enumSetting',
  component: () => import('@/page/enum/enumSetting.vue')
}, {
  path: '/newenumSetting',
  name: 'newenumSetting',
  component: () => import('@/page/enum/newenumSetting.vue')
}, {
  path: '/deviceConfiguration',
  name: 'deviceConfiguration',
  component: () => import('@/page/archives/deviceConfiguration.vue')
}]
